import React from 'react';
import './index.css';
import { Outlet } from 'react-router-dom';
import styled from '@emotion/styled';
import ChatSidebar from './components/ChatSidebar';

const ChatWrapper = styled.div`
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.colors.gray};
    padding: 16px;
    flex:1;
    display:flex;
    flex-direction: column;
`;

export default function ChatPage() {
  
  return (
    <div className='chat-section'>
        <ChatSidebar />
        <ChatWrapper>
            <Outlet />
        </ChatWrapper>
    </div>
  );
}